import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import PublicRoute from './components/PublicRoute/PublicRoute';
import RootRedirect from './components/RootRedirect/RootRedirect';
import LoginPage from './pages/LoginPage/LoginPage';
import DashboardPage from './pages/DashboardPage/DashboardPage';
import QuestDetailsPage from './pages/QuestDetailsPage/QuestDetailsPage';
import ModuleDetailsPage from './pages/ModuleDetailsPage/ModuleDetailsPage';
import TranscriptionPage from './pages/TranscriptionPage/TranscriptionPage';
import DailyChallengeDetailsPage from './pages/DailyChallengeDetailsPage/DailyChallengeDetailsPage';
import DCModuleDetailsPage from './pages/DCModuleDetailsPage/DCModuleDetailsPage';
import MasteryChallengeDetailsPage from './pages/MasteryChallengeDetailsPage/MasteryChallengeDetailsPage';
import MCModuleDetailsPage from './pages/MCModuleDetailsPage/MCModuleDetailsPage';
import ExperimentModuleDetailsPage from './pages/ExperimentModuleDetailsPage/ExperimentModuleDetailsPage';
import ThreadMessagesPage from './pages/ThreadMessagesPage/ThreadMessagesPage';
import CategoryDetailsPage from './pages/CategoryDetailsPage/CategoryDetailsPage';
import StoryDetailsPage from './pages/StoryDetailsPage/StoryDetailsPage';
import NotificationPage from './pages/NotificationPage/NotificationPage';
import './App.css';

function App(): JSX.Element {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <LoginPage />
                </PublicRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/quests"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/quests/:questId"
              element={
                <ProtectedRoute>
                  <QuestDetailsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/quests/:questId/modules/:moduleId"
              element={
                <ProtectedRoute>
                  <ModuleDetailsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/upload"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/feed"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/tags"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/transcription"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/global-coach"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/daily-challenges"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/daily-challenges/:challengeId"
              element={
                <ProtectedRoute>
                  <DailyChallengeDetailsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/daily-challenges/:challengeId/module/:moduleId"
              element={
                <ProtectedRoute>
                  <DCModuleDetailsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mastery-challenges"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mastery-challenges/:challengeId"
              element={
                <ProtectedRoute>
                  <MasteryChallengeDetailsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mastery-challenges/:challengeId/module/:moduleId"
              element={
                <ProtectedRoute>
                  <MCModuleDetailsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/audio-urls"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/all-users"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/user-feedback"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/category"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/category/:categoryId"
              element={
                <ProtectedRoute>
                  <CategoryDetailsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/experiment-modules"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/v3"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/v3/stories"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/v3/authors"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/v3/stories/:storyId"
              element={
                <ProtectedRoute>
                  <StoryDetailsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/notification"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/experiment-modules/:moduleId"
              element={
                <ProtectedRoute>
                  <ExperimentModuleDetailsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/thread/:threadId/:userId"
              element={
                <ProtectedRoute>
                  <ThreadMessagesPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
